<script lang="ts" >
import Component from 'vue-class-component'
import AdminList from '@/components/admin/AdminList.vue'
import { AloDbMissionPlanTemplate } from '@/models/alodb/AloDbMissionPlanTemplate'
import MissionOperatorFilter from '@/components/mission/MissionOperatorFilter.vue'

@Component({
  name: 'AdminMissionPlanTemplateList',
  components:{MissionOperatorFilter}
})

export default class AdminMissionPlanTemplateList extends AdminList<AloDbMissionPlanTemplate> {  
 
  get itemTypeName() {
    return "MissionPlanTemplate"
  }

  get componentExtendName() {
    return "MissionOperatorFilter"
  }


  get filter() {
    return this.$store.myGetters.adminMissionPlanTemplateFilter
  }

  get selectedFilterEnsId()
  {
    //@ts-ignore
    return this.$store.myGetters.filterMission?.ensIds?.at(0) ?? undefined
  }

  get isOperator()
    {
      return this.$store.myGetters.isOperator
    }  

    get isSysAdmin()
    {
      return this.$store.myGetters.isSysAdmin
    }  

  get items()  {             
    return this.$store.myGetters.missionPlanTemplates.filter(m => 
      (this.filter.search.length == 0 ||  m.searchString!.toLowerCase().indexOf(this.filter.search.toLowerCase()) > -1) 
      && ((!this.isOperator && !this.isSysAdmin)  || this.selectedFilterEnsId == undefined || m.ENS_ID == this.selectedFilterEnsId)

    )    

   // .filter()
  }

}
</script>